import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import Tilt from "react-parallax-tilt";
import "./AboutCEO.css";

const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.25 }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

function AboutCEO() {
  return (
    <div className="about-page">

      {/* Animated Gradient */}
      <div className="animated-bg" />

      {/* HERO */}
      <motion.section
        className="hero"
        variants={container}
        initial="hidden"
        animate="visible"
      >
        <motion.h1 variants={fadeUp}>
          Powering The <span>Digital Future</span>
        </motion.h1>

        <motion.p variants={fadeUp}>
         Enterprise Solutions powered by Cloud & AI
        </motion.p>
      </motion.section>

      {/* CEO CARD */}
      <section className="ceo-section">
        <motion.div
          className="ceo-card glass"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Tilt
            tiltMaxAngleX={10}
            tiltMaxAngleY={10}
            glareEnable
            glareMaxOpacity={0.25}
            scale={1.06}
          >
            <motion.img
              src="/ceo.png"
              alt="CEO"
              className="ceo-image"
              animate={{ y: [0, -12, 0] }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </Tilt>

          <div className="ceo-content">
            <h2>Er. Ranjan Kumar Singh</h2>
            <span>Founder & CEO</span>

            <p>
              Visionary technology leader driving next-gen SaaS platforms,
              intelligent automation, and secure enterprise ecosystems.
              Passionate about innovation, scalability, and global impact.
            </p>
          </div>
        </motion.div>
      </section>

      {/* STATS */}
      <section className="stats">
        {[
          { num: 200, label: "Projects Delivered" },
          { num: 80, label: "Enterprise Clients" },
          { num: 15, label: "Countries Served" },
          { num: 99, label: "Success Rate %" }
        ].map((item, i) => (
          <motion.div
            key={i}
            className="stat-card glass"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.15 }}
            viewport={{ once: true }}
            whileHover={{ y: -10, scale: 1.08 }}
          >
            <h3>
              <CountUp end={item.num} duration={2.5} />+
            </h3>
            <p>{item.label}</p>
          </motion.div>
        ))}
      </section>

      {/* CTA */}
      <section className="cta">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Let’s Build The Future Together
        </motion.h2>
         </section>
         {/* MOVING WAVE LINES */}
<div className="wave-line-wrapper">
  <svg
    className="wave-line"
    viewBox="0 0 1200 120"
    preserveAspectRatio="none"
  >
    <defs>
      <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#00f2fe" />
        <stop offset="50%" stopColor="#4facfe" />
        <stop offset="100%" stopColor="#7f00ff" />
      </linearGradient>
    </defs>

    {/* Line 1 */}
    <path
      className="wave wave1"
      d="M0,60 C150,20 350,100 600,60 850,20 1050,100 1200,60"
      fill="none"
      stroke="url(#gradient)"
      strokeWidth="3"
    />

    {/* Line 2 */}
    <path
      className="wave wave2"
      d="M0,70 C150,30 350,110 600,70 850,30 1050,110 1200,70"
      fill="none"
      stroke="url(#gradient)"
      strokeWidth="3"
    />

    {/* Line 3 */}
    <path
      className="wave wave3"
      d="M0,80 C150,40 350,120 600,80 850,40 1050,120 1200,80"
      fill="none"
      stroke="url(#gradient)"
      strokeWidth="3"
    />
  </svg>
</div>
         </div>
         
  );
}

export default AboutCEO;